import { useTranslation } from 'react-i18next'

export default function HomeHero() {
  const { t } = useTranslation('common')

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20modern%20digital%20content%20creation%20workspace%20with%20floating%20colorful%20abstract%20geometric%20shapes%20in%20warm%20orange%20and%20coral%20gradients%2C%20creative%20studio%20atmosphere%2C%20soft%20diffused%20lighting%2C%20dreamy%20ethereal%20mood%2C%20clean%20minimal%20composition%2C%20artistic%20digital%20art%20style%20with%20subtle%20gradients%20and%20floating%20elements&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
        alt="快猫短视频"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-20 md:py-28">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 mb-4 md:mb-6 leading-tight">
          {t('home.heroTitle')}
          <br />
          <span className="text-primary-400">{t('home.heroTitleHighlight')}</span>
        </h1>
        <p className="text-background-200/90 text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {t('home.heroSubtitle')}
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <button className="px-6 md:px-8 py-3 md:py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-download-2-line mr-2"></i>
            {t('home.downloadApp')}
          </button>
          <a
            href="#hot-videos"
            className="px-6 md:px-8 py-3 md:py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-sm md:text-base font-medium border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {t('home.exploreContent')}
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 md:gap-12 mt-12 md:mt-16 flex-wrap">
          {[
            { value: '5000万+', label: t('home.statsUsers') },
            { value: '200万+', label: t('home.statsVideos') },
            { value: '50万+', label: t('home.statsCreators') },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}